import * as React from "react";
const Supplier = (props) => (
  <svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M28.5539 9.5865L16.5006 16.5598L4.44727 9.5865C4.9806 8.59984 5.75393 7.73317 6.6206 7.25317L13.7406 3.3065C15.2606 2.45317 17.7406 2.45317 19.2606 3.3065L26.3806 7.25317C27.2473 7.73317 28.0206 8.59984 28.5539 9.5865Z"
        fill="#344054"
      />
      <path
        d="M28.5539 9.5865L16.5006 16.5598L4.44727 9.5865C4.9806 8.59984 5.75393 7.73317 6.6206 7.25317L13.7406 3.3065C15.2606 2.45317 17.7406 2.45317 19.2606 3.3065L26.3806 7.25317C27.2473 7.73317 28.0206 8.59984 28.5539 9.5865Z"
        fill="url(#paint0_linear_3639_300855)"
      />
    </g>
    <g opacity={0.6}>
      <path
        d="M16.5008 16.5598V29.3331C15.5008 29.3331 14.5008 29.1198 13.7408 28.6931L6.62083 24.7464C5.0075 23.8531 3.6875 21.6131 3.6875 19.7731V12.2264C3.6875 11.3731 3.98083 10.4398 4.4475 9.58643L16.5008 16.5598Z"
        fill="#344054"
      />
      <path
        d="M16.5008 16.5598V29.3331C15.5008 29.3331 14.5008 29.1198 13.7408 28.6931L6.62083 24.7464C5.0075 23.8531 3.6875 21.6131 3.6875 19.7731V12.2264C3.6875 11.3731 3.98083 10.4398 4.4475 9.58643L16.5008 16.5598Z"
        fill="url(#paint1_linear_3639_300855)"
      />
    </g>
    <path
      d="M29.3143 12.2264V19.7731C29.3143 21.6131 27.9943 23.8531 26.381 24.7464L19.261 28.6931C18.501 29.1198 17.501 29.3331 16.501 29.3331V16.5598L28.5543 9.58643C29.021 10.4398 29.3143 11.3731 29.3143 12.2264Z"
      fill="#344054"
    />
    <path
      d="M29.3143 12.2264V19.7731C29.3143 21.6131 27.9943 23.8531 26.381 24.7464L19.261 28.6931C18.501 29.1198 17.501 29.3331 16.501 29.3331V16.5598L28.5543 9.58643C29.021 10.4398 29.3143 11.3731 29.3143 12.2264Z"
      fill="url(#paint2_linear_3639_300855)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300855"
        x1={28.5539}
        y1={16.5598}
        x2={28.5539}
        y2={2.6665}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B23EA" />
        <stop offset={1} stopColor="#5F72BD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300855"
        x1={16.5008}
        y1={29.3331}
        x2={16.5008}
        y2={9.58643}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B23EA" />
        <stop offset={1} stopColor="#5F72BD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300855"
        x1={29.3143}
        y1={29.3331}
        x2={29.3143}
        y2={9.58643}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B23EA" />
        <stop offset={1} stopColor="#5F72BD" />
      </linearGradient>
    </defs>
  </svg>
);
export default Supplier;
